import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.proposal || initialState;

export const selectTeamProposal = createSelector([selectSlice], state => state);
